import type { TFunction } from 'i18next';
import type { ValidateSchemaResult } from '../../lib/validateSchema';

/** "No problems found." or "2 problems · 1 warning". */
export function summarizeReport(report: ValidateSchemaResult, t: TFunction<'knowledge'>): string {
  if (report.problems.length === 0) return t('taxonomy.taxonomyDetail.noProblemsFound');
  return [
    report.errorCount > 0 &&
      t('taxonomy.taxonomyDetail.problemCount', { count: report.errorCount }),
    report.warningCount > 0 &&
      t('taxonomy.taxonomyDetail.warningCount', { count: report.warningCount }),
  ]
    .filter(Boolean)
    .join(' · ');
}
